import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import GroupItem from '../item/groupItem';
import AbstractCommand from './abstractCommand';

/**
 * Ungroup item command
 *
 * @class UnGroupItemCommand
 * @extends AbstractCommand
 */
export default class UnGroupItemCommand extends AbstractCommand {
    constructor(itemCollection, selection, groupItem) {
        super();
        if (!(groupItem instanceof GroupItem)) {
            throw new Error('Only group item can be ungrouped.');
        }

        this.itemCollection = itemCollection;
        this.selection = selection;
        this.groupItem = groupItem;
        this.groupItems = groupItem.getItems();
    }

    /**
     * Execute command
     */
    execute() {
        this.selection.clear();

        this.groupItem.clearItems();
        this.itemCollection.remove(this.groupItem);
        this.itemCollection.add(this.groupItems);

        this.selection.selectItems(this.groupItems, true);
    }

    /**
     * Unexecute command
     */
    unexecute() {
        this.selection.clear();

        this.groupItem.clearItems();
        this.itemCollection.remove(this.groupItems);
        this.groupItem.addItems(this.groupItems);
        this.itemCollection.add(this.groupItem);

        this.selection.selectItem(this.groupItem, true);
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return 'Ungroup';
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.UnGroupItemCommand = UnGroupItemCommand;
